import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('CallIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__call" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.49 22.54">
        <path className="foreground" d="M10.78,13.87a18.44,18.44,0,0,1-3.9-4.68l-.51-.94C6.55,8,7.9,6.6,8.48,5.82c.74-1-.33-1.87-.33-1.87s-3-3-3.68-3.59A1.47,1.47,0,0,0,3,.09C1.58,1,.1,1.82,0,5.71,0,9.34,2.74,13.08,5.72,16c3,3.28,7.08,6.56,11.05,6.56s4.69-1.58,5.62-3a1.47,1.47,0,0,0-.26-1.47c-.6-.68-3.59-3.68-3.59-3.68s-.89-1.07-1.87-.33c-.74.55-2.05,1.77-2.37,2.07A26.89,26.89,0,0,1,10.78,13.87Z"/>
      </svg>
    ), el);
  });
};
